import {
  RESET_COMPONENT_STATE,
  COMPONENT_UPLOAD_AND_SAVE_FILES_PENDING,
  COMPONENT_UPLOAD_AND_SAVE_FILES_REQUEST,
  COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS,
  COMPONENT_UPLOAD_AND_SAVE_FILES_FAILURE,
  COMPONENT_REMOVE_FILE_SERVER_REQUEST,
  COMPONENT_REMOVE_FILE_SERVER_SUCCESS,
  COMPONENT_REMOVE_FILE_SERVER_FAILURE,
} from '../../../actions/actionTypes';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';

import { fileComponentKey as cKey } from '../../../helpers/reducers';

const INITIAL_STATE = {
  status: PENDING,
  errorMessage: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_COMPONENT_STATE:
      if (action.payload == null) {
        return {
          ...INITIAL_STATE,
        };
      }

      const fileCKey = cKey(action.payload);
      if (!state[fileCKey]) return state;

      // only clear the state if its not requesting, otherwise we'll want to
      // indicate that in the UI (?)
      const status = state[fileCKey].status;
      if (status !== REQUESTING) {
        let retState = {
          ...state,
        };
        delete retState[fileCKey];
        return retState;
      }

      return state;

    case COMPONENT_UPLOAD_AND_SAVE_FILES_PENDING:
      if (!action.payload.objectId) {
        return state;
      }
      return {
        ...state,
        status: PENDING,
        errorMessage: null,
        [cKey(action.payload)]: {
          objectType: action.payload.objectType,
          objectId: action.payload.objectId,
          status: PENDING,
        },
      };
    case COMPONENT_UPLOAD_AND_SAVE_FILES_REQUEST:
      return {
        ...state,
        status: REQUESTING,
        errorMessage: null,
        [cKey(action.payload)]: {
          objectType: action.payload.objectType,
          objectId: action.payload.objectId,
          status: REQUESTING,
        },
      };
    case COMPONENT_UPLOAD_AND_SAVE_FILES_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        [cKey(action.payload)]: {
          objectType: action.payload.objectType,
          objectId: action.payload.objectId,
          status: SUCCESS,
        },
      };
    case COMPONENT_UPLOAD_AND_SAVE_FILES_FAILURE:
      return {
        ...state,
        status: FAILED,
        errorMessage: action.payload.errorMessage,
        [cKey(action.payload)]: {
          objectType: action.payload.objectType,
          objectId: action.payload.objectId,
          status: FAILED,
          errorMessage: action.payload.errorMessage,
        },
      };
    case COMPONENT_REMOVE_FILE_SERVER_REQUEST:
      return {
        ...state,
        status: REQUESTING,
        errorMessage: null,
      };
    case COMPONENT_REMOVE_FILE_SERVER_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        errorMessage: null,
      };
    case COMPONENT_REMOVE_FILE_SERVER_FAILURE:
      return {
        ...state,
        status: FAILED,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}
